// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lPBf","clinicsSelect":"styles_clinicsSelect__D8ap8"};